
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as analyticsbKoOTZxjasWtFe8GOjBDIsl35ZvSF4cGyKw51K_R74oMeta } from "/app/pages/admin/analytics.vue?macro=true";
import { default as connectionsgWrtFMgjTnXuRIRhzzuFY8iAmyyGSXFlDGxqdDmCuT0Meta } from "/app/pages/admin/connections.vue?macro=true";
import { default as conversationsD8AbVIxi7VNHcWaKSlw4HTbUwZO6pWy9hLJl2FXBCo0Meta } from "/app/pages/admin/conversations.vue?macro=true";
import { default as gyms25UR8uWWEZD0Ghjx5n8rsqLDNnXcf2keXFQyHTjlWswMeta } from "/app/pages/admin/gyms.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as messagesVzjxx6gsnQSSqQABRVhyKyqMfz6zINmfttucS8ZEyOsMeta } from "/app/pages/admin/messages.vue?macro=true";
import { default as moderationwpQinRGCuPNJQ_45ICcDMxfatd9OU_45CtjLeFtLb18P8sEMeta } from "/app/pages/admin/moderation.vue?macro=true";
import { default as reportsobl9gFceYZYm_as9afJP0H22Yjh56xIaQK8JVHXUh9cMeta } from "/app/pages/admin/reports.vue?macro=true";
import { default as userIPO0BDab0UTv8Xq6qQ0ZpDCpw_nmjeCa6dbYk1eWFj4Meta } from "/app/pages/admin/user.vue?macro=true";
import { default as users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta } from "/app/pages/admin/users.vue?macro=true";
import { default as verificationsdnH06LHtsnChCW_f6QlJJSY5cBWRG__yj2N0StFkgHIMeta } from "/app/pages/admin/verifications.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as _91id_93t388HWN8dvV93msKigLmo8_ZbZACbMi1fGSJRYjOzp8Meta } from "/app/pages/blog/[id].vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as userrAIsyp2p7iWeCCjK4lBCsAivWt2_45Jhk1cISs7OO6ezUMeta } from "/app/pages/dashboard/user.vue?macro=true";
import { default as _91id_93sZ7kUB_45ULg2CzYpPqZMAgyENm6OU44wKbz_AC0BID50Meta } from "/app/pages/gyms/[id].vue?macro=true";
import { default as indexMUpOxrACAmOFBl6b0orjzCi_45nHBuIk5LFd81rFZ2t7AMeta } from "/app/pages/gyms/index.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexZWC5OtfkmGc9hy3yXe3pYXRpuYEpOmKMhwSvjoFB08oMeta } from "/app/pages/matches/index.vue?macro=true";
import { default as my_45matchesWOcrSZZ2uxB4ako3hEFnpN4PS_45wkgTueGacsmJkfPMIMeta } from "/app/pages/matches/my-matches.vue?macro=true";
import { default as _91id_93wUMo1F52GrmTP02jgEYb34AgZmq09cN_45_NEnbcL9TnEMeta } from "/app/pages/messages/[id].vue?macro=true";
import { default as indexFftkOkvQy_xh2eJrSXUDr5_45tYtTmXoPgzbxwZSj6LI0Meta } from "/app/pages/messages/index.vue?macro=true";
import { default as indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta } from "/app/pages/onboarding/index.vue?macro=true";
import { default as step_451_dhY_45_45tdXYqMHBiUq6XaX0FENmUuyXKGedbAaI04WpMMeta } from "/app/pages/onboarding/step-1.vue?macro=true";
import { default as step_452Qv1FhtK7md3Yl1C9ofI4BlbRrmrLSUM9dn99Nr_45TTy0Meta } from "/app/pages/onboarding/step-2.vue?macro=true";
import { default as step_4539nLny5YLOoMzwFMQ7OSyogKAUxtbzgTQAilIdg74m_MMeta } from "/app/pages/onboarding/step-3.vue?macro=true";
import { default as step_454qBQK4gQW2LztmD2_nKo04pIYWBXS2xX0bDXb25pw53cMeta } from "/app/pages/onboarding/step-4.vue?macro=true";
import { default as step_455eBUWXqMf7K5KEyPu6c2hldjnb9rXv5qGc0smu4l6PKkMeta } from "/app/pages/onboarding/step-5.vue?macro=true";
import { default as pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta } from "/app/pages/pricing.vue?macro=true";
import { default as _91userId_93fFVMYuAYt7cqSJc1nVmL2kZJWo7keWosaeHwW856NuIMeta } from "/app/pages/profile/[userId].vue?macro=true";
import { default as editZBKHq45q67yiBF3FiHxAaGOkw_45TMcifAAfnfD5_457zHIMeta } from "/app/pages/profile/edit.vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as indexmap9CoX4lHrhXQTleLul_QN8W6UpYaR2fk0Cevox_ZQMeta } from "/app/pages/verification/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta || {},
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "admin-analytics",
    path: "/admin/analytics",
    meta: analyticsbKoOTZxjasWtFe8GOjBDIsl35ZvSF4cGyKw51K_R74oMeta || {},
    component: () => import("/app/pages/admin/analytics.vue")
  },
  {
    name: "admin-connections",
    path: "/admin/connections",
    meta: connectionsgWrtFMgjTnXuRIRhzzuFY8iAmyyGSXFlDGxqdDmCuT0Meta || {},
    component: () => import("/app/pages/admin/connections.vue")
  },
  {
    name: "admin-conversations",
    path: "/admin/conversations",
    meta: conversationsD8AbVIxi7VNHcWaKSlw4HTbUwZO6pWy9hLJl2FXBCo0Meta || {},
    component: () => import("/app/pages/admin/conversations.vue")
  },
  {
    name: "admin-gyms",
    path: "/admin/gyms",
    meta: gyms25UR8uWWEZD0Ghjx5n8rsqLDNnXcf2keXFQyHTjlWswMeta || {},
    component: () => import("/app/pages/admin/gyms.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-messages",
    path: "/admin/messages",
    meta: messagesVzjxx6gsnQSSqQABRVhyKyqMfz6zINmfttucS8ZEyOsMeta || {},
    component: () => import("/app/pages/admin/messages.vue")
  },
  {
    name: "admin-moderation",
    path: "/admin/moderation",
    meta: moderationwpQinRGCuPNJQ_45ICcDMxfatd9OU_45CtjLeFtLb18P8sEMeta || {},
    component: () => import("/app/pages/admin/moderation.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: reportsobl9gFceYZYm_as9afJP0H22Yjh56xIaQK8JVHXUh9cMeta || {},
    component: () => import("/app/pages/admin/reports.vue")
  },
  {
    name: "admin-user",
    path: "/admin/user",
    component: () => import("/app/pages/admin/user.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta || {},
    component: () => import("/app/pages/admin/users.vue")
  },
  {
    name: "admin-verifications",
    path: "/admin/verifications",
    meta: verificationsdnH06LHtsnChCW_f6QlJJSY5cBWRG__yj2N0StFkgHIMeta || {},
    component: () => import("/app/pages/admin/verifications.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "blog-id",
    path: "/blog/:id()",
    meta: _91id_93t388HWN8dvV93msKigLmo8_ZbZACbMi1fGSJRYjOzp8Meta || {},
    component: () => import("/app/pages/blog/[id].vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-user",
    path: "/dashboard/user",
    component: () => import("/app/pages/dashboard/user.vue")
  },
  {
    name: "gyms-id",
    path: "/gyms/:id()",
    meta: _91id_93sZ7kUB_45ULg2CzYpPqZMAgyENm6OU44wKbz_AC0BID50Meta || {},
    component: () => import("/app/pages/gyms/[id].vue")
  },
  {
    name: "gyms",
    path: "/gyms",
    meta: indexMUpOxrACAmOFBl6b0orjzCi_45nHBuIk5LFd81rFZ2t7AMeta || {},
    component: () => import("/app/pages/gyms/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "matches",
    path: "/matches",
    meta: indexZWC5OtfkmGc9hy3yXe3pYXRpuYEpOmKMhwSvjoFB08oMeta || {},
    component: () => import("/app/pages/matches/index.vue")
  },
  {
    name: "matches-my-matches",
    path: "/matches/my-matches",
    meta: my_45matchesWOcrSZZ2uxB4ako3hEFnpN4PS_45wkgTueGacsmJkfPMIMeta || {},
    component: () => import("/app/pages/matches/my-matches.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93wUMo1F52GrmTP02jgEYb34AgZmq09cN_45_NEnbcL9TnEMeta || {},
    component: () => import("/app/pages/messages/[id].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexFftkOkvQy_xh2eJrSXUDr5_45tYtTmXoPgzbxwZSj6LI0Meta || {},
    component: () => import("/app/pages/messages/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta || {},
    component: () => import("/app/pages/onboarding/index.vue")
  },
  {
    name: "onboarding-step-1",
    path: "/onboarding/step-1",
    meta: step_451_dhY_45_45tdXYqMHBiUq6XaX0FENmUuyXKGedbAaI04WpMMeta || {},
    component: () => import("/app/pages/onboarding/step-1.vue")
  },
  {
    name: "onboarding-step-2",
    path: "/onboarding/step-2",
    meta: step_452Qv1FhtK7md3Yl1C9ofI4BlbRrmrLSUM9dn99Nr_45TTy0Meta || {},
    component: () => import("/app/pages/onboarding/step-2.vue")
  },
  {
    name: "onboarding-step-3",
    path: "/onboarding/step-3",
    meta: step_4539nLny5YLOoMzwFMQ7OSyogKAUxtbzgTQAilIdg74m_MMeta || {},
    component: () => import("/app/pages/onboarding/step-3.vue")
  },
  {
    name: "onboarding-step-4",
    path: "/onboarding/step-4",
    meta: step_454qBQK4gQW2LztmD2_nKo04pIYWBXS2xX0bDXb25pw53cMeta || {},
    component: () => import("/app/pages/onboarding/step-4.vue")
  },
  {
    name: "onboarding-step-5",
    path: "/onboarding/step-5",
    meta: step_455eBUWXqMf7K5KEyPu6c2hldjnb9rXv5qGc0smu4l6PKkMeta || {},
    component: () => import("/app/pages/onboarding/step-5.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "profile-userId",
    path: "/profile/:userId()",
    meta: _91userId_93fFVMYuAYt7cqSJc1nVmL2kZJWo7keWosaeHwW856NuIMeta || {},
    component: () => import("/app/pages/profile/[userId].vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editZBKHq45q67yiBF3FiHxAaGOkw_45TMcifAAfnfD5_457zHIMeta || {},
    component: () => import("/app/pages/profile/edit.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta || {},
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta || {},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: "verification",
    path: "/verification",
    meta: indexmap9CoX4lHrhXQTleLul_QN8W6UpYaR2fk0Cevox_ZQMeta || {},
    component: () => import("/app/pages/verification/index.vue")
  }
]